<div [ngClass]="{'loader': true, 'login-spinner': isLoading?.customColor}" *ngIf="isLoading?.show">
    <mat-spinner
                 mode="indeterminate"
                 [diameter]=40>
    </mat-spinner>
</div>
